import { defineMessages } from "@ai360/core/intl";

export const messages = defineMessages({
    name: {
        id: "setup.steeringData.name",
        defaultMessage: "Name",
    },
    location: {
        id: "setup.steeringData.location",
        defaultMessage: "Location",
    },
    fileName: {
        id: "setup.steeringData.fileName",
        defaultMessage: "File Name / URL",
    },
    lastModified: {
        id: "setup.steeringData.lastModified",
        defaultMessage: "Last Modified",
    },
    embeddingStatus: {
        id: "setup.steeringData.embeddingStatus",
        defaultMessage: "Status",
    },
    deleteConfirmationTitle: {
        id: "setup.steeringData.deleteConfirmationTitle",
        defaultMessage: "Delete Confirmation",
    },
    deleteConfirmationMessage: {
        id: "setup.steeringData.deleteConfirmationMessage",
        defaultMessage: 'Are you sure you want to delete "{name}" ({type})?',
    },
    emptyStateMessage: {
        id: "setup.steeringData.emptyStateMessage",
        defaultMessage: "No steering datasets are configured. Use the Add button to create one.",
    },
    // Form messages
    addTitle: {
        id: "setup.steeringData.addTitle",
        defaultMessage: "Add Steering Dataset",
    },
    editTitle: {
        id: "setup.steeringData.editTitle",
        defaultMessage: "Edit Steering Dataset",
    },
    nameLabel: {
        id: "setup.steeringData.nameLabel",
        defaultMessage: "Name",
    },
    dataSourceTypeLabel: {
        id: "setup.steeringData.dataSourceTypeLabel",
        defaultMessage: "Data Source Type",
    },
    steeringTypeLabel: {
        id: "setup.steeringData.steeringTypeLabel",
        defaultMessage: "Steering Type",
    },
    fileUploadLabel: {
        id: "setup.steeringData.fileUploadLabel",
        defaultMessage: "File Upload",
    },
    productRecommendationsLabel: {
        id: "setup.steeringData.productRecommendationsLabel",
        defaultMessage: "Product Recommendations",
    },
    publicUrlLabel: {
        id: "setup.steeringData.publicUrlLabel",
        defaultMessage: "Public URL",
    },
    publicUrlTextLabel: {
        id: "setup.steeringData.publicUrlTextLabel",
        defaultMessage: "Public URL (Text)",
    },
    publicUrlFilesLabel: {
        id: "setup.steeringData.publicUrlFilesLabel",
        defaultMessage: "Public URL (Files)",
    },
    fileUploadSectionLabel: {
        id: "setup.steeringData.fileUploadSectionLabel",
        defaultMessage: "Upload File (PDF, DOC, DOCX, TXT, CSV, XLS, XLSX, ZIP)",
    },
    currentFile: {
        id: "setup.steeringData.currentFile",
        defaultMessage: "Current file: {fileName}",
    },
    hierarchyLevelsLabel: {
        id: "setup.steeringData.hierarchyLevelsLabel",
        defaultMessage: "Location Affiliations",
    },
    notesLabel: {
        id: "setup.steeringData.notesLabel",
        defaultMessage: "Notes",
    },
    // Child sublist (files crawled from a url-files parent)
    // Child sublist labels — file-oriented (url-files parent, or a manual upload).
    filesTitle: {
        id: "setup.steeringData.filesTitle",
        defaultMessage: "Files",
    },
    filesCount: {
        id: "setup.steeringData.filesCount",
        defaultMessage: "{count} file{count, plural, one {} other {s}}",
    },
    filesEmpty: {
        id: "setup.steeringData.filesEmpty",
        defaultMessage: "No files found for this URL.",
    },
    childColumnFile: {
        id: "setup.steeringData.childColumnFile",
        defaultMessage: "File",
    },
    childDeleteConfirmationMessage: {
        id: "setup.steeringData.childDeleteConfirmationMessage",
        defaultMessage:
            "Are you sure you want to delete {count} selected file{count, plural, one {} other {s}}?",
    },
    // Child sublist labels — page-oriented (url-text parent: children are the
    // linked pages whose text was captured, not files).
    pagesTitle: {
        id: "setup.steeringData.pagesTitle",
        defaultMessage: "Pages",
    },
    pagesCount: {
        id: "setup.steeringData.pagesCount",
        defaultMessage: "{count} page{count, plural, one {} other {s}}",
    },
    pagesEmpty: {
        id: "setup.steeringData.pagesEmpty",
        defaultMessage: "No linked pages found for this URL.",
    },
    childColumnPage: {
        id: "setup.steeringData.childColumnPage",
        defaultMessage: "Page",
    },
    pageDeleteConfirmationMessage: {
        id: "setup.steeringData.pageDeleteConfirmationMessage",
        defaultMessage:
            "Are you sure you want to delete {count} selected page{count, plural, one {} other {s}}?",
    },
    // Shared child sublist actions.
    childDeleteSelected: {
        id: "setup.steeringData.childDeleteSelected",
        defaultMessage: "Delete Selected",
    },
    childDelete: {
        id: "setup.steeringData.childDelete",
        defaultMessage: "Delete",
    },
    childDeleteConfirmationTitle: {
        id: "setup.steeringData.childDeleteConfirmationTitle",
        defaultMessage: "Delete Confirmation",
    },
    childColumnStatus: {
        id: "setup.steeringData.childColumnStatus",
        defaultMessage: "Status",
    },
});
